/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { request } from '@mairistem/tools';

import { BASE_URL_ETATCIVIL } from '@/constants/url';
import type { MentionAnts, OptionCodeAnts } from '@/types';

const URL_MENTION_ANTS = `${BASE_URL_ETATCIVIL}/mention-ants`;

/**
 * Charge le référentiel des mentions ANTS quand `actif` passe à `true` (à l'ouverture d'une
 * modale de mention) et en dérive les options du dropdown « Code ANTS ».
 */
const useOptionsCodeAnts = (actif: boolean) => {
  const [options, setOptions] = React.useState<OptionCodeAnts[]>([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!actif) {
      setOptions([]);
      return;
    }

    setLoading(true);
    request
      .get(URL_MENTION_ANTS)
      .then(({ data: categories }: { data: MentionAnts[] }) => {
        setOptions(
          _.flatMap(categories, (categorie) =>
            _.map(categorie?.mentions, (mentionAnts) => ({
              key: Number(mentionAnts?.identifiant),
              value: Number(mentionAnts?.identifiant),
              text: `${categorie?.codeRefAnts} - ${categorie?.type} - ${mentionAnts?.intitule}`,
            })),
          ),
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [actif]);

  return { options, loading };
};

export default useOptionsCodeAnts;
